import { render } from "./TaskTeam.vue?vue&type=template&id=47bc4552"
import script from "./TaskTeam.vue?vue&type=script&lang=js"
export * from "./TaskTeam.vue?vue&type=script&lang=js"

import "./TaskTeam.vue?vue&type=style&index=0&id=47bc4552&lang=less"

import exportComponent from "F:\\work\\git\\yunchi\\yc-vue-source\\cloud_share_lib\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__